import React, { useEffect, useState } from "react";
import { MapContainer, TileLayer, Marker, useMapEvents, useMap } from "react-leaflet";
import L from "leaflet";
import toast from "react-hot-toast";
import { base_url } from "Backend/api";

const center = [26.229, 50.586]; // Bahrain

// fix marker icon
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

const LocationMarker = ({ setSelectedPosition, setDescription }) => {
  useMapEvents({
    click: async (e) => {
      const { lat, lng } = e.latlng;

      setSelectedPosition([lat, lng]);

      try {
        const res = await fetch(
          `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`
        );
        const data = await res.json();

        if (data.display_name) {
          setDescription(data.display_name);
        } else {
          toast.error("لم يتم العثور على عنوان");
        }
      } catch {
        toast.error("فشل جلب العنوان");
      }
    },
  });

  return null;
};

const LocationPicker = ({ onClose, onAddressAdded }) => {
  const [selectedPosition, setSelectedPosition] = useState(center);
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);

  const handleAddAddress = async () => {
    if (!description && !selectedPosition) {
      toast.error("من فضلك اختر موقع");
      return;
    }

    const finalDescription =
      description ||
      `الموقع: ${selectedPosition[0]},${selectedPosition[1]}`;

    setLoading(true);

    try {
      const token = localStorage.getItem("token");

      const response = await fetch(`${base_url}/api/addresses`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          description: finalDescription,
          map_location: `${selectedPosition[0]},${selectedPosition[1]}`,
        }),
      });

      const data = await response.json();

      if (data.status) {
        toast.success("تم إضافة العنوان");
        onClose();
        onAddressAdded();
      } else {
        toast.error(data.message);
      }
    } catch (err) {
      
    }

    setLoading(false);
  };

  useEffect(() => {
    if (!navigator.geolocation) {
      toast.error("المتصفح لا يدعم تحديد الموقع");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const lat = position.coords.latitude;
        const lng = position.coords.longitude;

        setSelectedPosition([lat, lng]);

        try {
          const res = await fetch(
            `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`
          );
          const data = await res.json();

          if (data.display_name) {
            setDescription(data.display_name);
          }
        } catch (error) {
          console.log("Location error:", error);
        }
      },
      () => {}
    );
  }, []);


  const ChangeMapView = ({ center }) => {
    const map = useMap();

    useEffect(() => {
      map.setView(center, 15, {
        animate: true,
      });
    }, [center, map]);

    return null;
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
      <div className="bg-white rounded-lg w-full max-w-3xl p-6 shadow-lg relative">

        <button
          className="absolute top-3 right-3 text-xl"
          onClick={onClose}
        >
          ✕
        </button>

        <h2 className="text-lg font-bold mb-4 text-center font-[cairo]">
          اختر موقعك
        </h2>

        {/* <input
          type="text"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="وصف العنوان"
          className="border p-2 w-full rounded mb-3 text-right font-[cairo]"
        /> */}
        <div className="border p-2 w-full rounded mb-3 text-right font-[cairo] bg-gray-50">
  {description || "اختر موقع على الخريطة لعرض العنوان"}
</div>

        {/* <MapContainer
          center={selectedPosition}
          zoom={14}
          style={{ height: "400px", width: "100%" }}
        >
          <TileLayer
            attribution="© OpenStreetMap"
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />

          <Marker position={selectedPosition} />
          <LocationMarker
            setSelectedPosition={setSelectedPosition}
            setDescription={setDescription}
          />
        </MapContainer> */}
        <MapContainer
          center={selectedPosition}
          zoom={14}
          style={{ height: "400px", width: "100%" }}
        >
          <TileLayer
            attribution="© OpenStreetMap"
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />

          <ChangeMapView center={selectedPosition} />

          <Marker position={selectedPosition} />

          <LocationMarker
            setSelectedPosition={setSelectedPosition}
            setDescription={setDescription}
          />
        </MapContainer>

        <button
          onClick={handleAddAddress}
          disabled={loading}
          className="mt-4 w-full bg-primary text-white p-3 rounded font-[cairo]"
        >
          {loading ? "جاري الإضافة..." : "إضافة العنوان"}
        </button>
      </div>
    </div>
  );
};

export default LocationPicker;